import React from "react";
import loadingImg from "../assets/rollz2cd.png";

const Loader = () => {
  return (
    <div className="loading_img">
      <img src={loadingImg} alt="Loading.." className="img-fluid" />
    </div>
  );
};

export default Loader;
